// extracted by mini-css-extract-plugin
export var content = "InitialSignUpScreen-module__content___hZxjr";
export var create = "InitialSignUpScreen-module__create___UfRE5";
export var divider = "InitialSignUpScreen-module__divider___G8YwO";
export var inline = "InitialSignUpScreen-module__inline___OSSie";
export var signUpLogInContainer = "InitialSignUpScreen-module__signUpLogInContainer___Lytfu";